// API constants
const sortArrayByPriority = (array, priority) => {
  priority.reverse().forEach(priorityItem => {
    const index = array.findIndex(
      item => item.value.toLowerCase() === priorityItem,
    );
    const entity = array[index];
    array.splice(index, 1);
    array.unshift(entity);
  });

  return array;
};

// array of objects
export const sortByPriority = (array, key, priority) => {
  priority.reverse().forEach(priorityItem => {
    const index = array.findIndex(item => item[key] === priorityItem);

    if (index > -1) {
      const entity = array[index];
      array.splice(index, 1);
      array.unshift(entity);
    }
  });

  return array;
};

export default sortArrayByPriority;



// WEBPACK FOOTER //
// ./src/utils/sorting/sortArrayByPriority.js